module.exports = __webpack_public_path__ + "src/assets/img/photo_saj1.d9e010ad.jpg";